class OwnersvoiceDetailController {
    constructor() {
        this.setPlannerDetailforSP();

        this.setPlannerClick();
        this.setLayoutModal();
    }

    
    setPlannerClick() {
        let $detail = $('.ownersvoice-detail__planner-detail-item');
        $detail.slideUp(16);
        $('.ownersvoice-detail__planner-item').each(function () {
            let $this = $(this);
            $this.on('click', function () {
                let target = $this.data('detailid');
                $detail.slideUp(16);
                $(`.${target}`).slideDown();
            });
        });
        $('.ownersvoice-detail__planner-detail-item-close').each(function () {
            let $this = $(this);
            $this.on('click', function () {
                $detail.slideUp();
            });
        });
    }
    setLayoutModal() {
        $('#js-ownersvoice-detail__layout-zoom').on('click', function(e){
            e.preventDefault();
            $('#js-ownersvoice-detail__layout-modal').addClass('is-open');

        });
        $('.common-popup__close').on('click', function(e){
            e.preventDefault();
            $('#js-ownersvoice-detail__layout-modal').removeClass('is-open');
        });
        $('.common-popup').on('click', function(e){
            e.preventDefault();
            if ($(e.target).hasClass('is-open')) {
                $('.common-popup').removeClass('is-open');
                setTimeout(()=>{
                    $('#js-ownersvoice-detail__layout-modal').removeClass('is-open');
                }, 500);
            }
            
        });
    }

    setPlannerDetailforSP() {
        if(window.UA.isSP) {
            let $clone = $('#js-ownersvoice-detail__planner-detail .ownersvoice-detail__planner-detail-item').clone(true, true);
            $('#js-ownersvoice-detail__planner-detailsp').append($clone);
        }
    }
}

export default OwnersvoiceDetailController;
